export default function (Component) {
Component.options.__docs = "<p>Use <code>firstColumnFixed</code> on <code>FdTable</code> in order to make the first column stay fixed when scrolling.</p>\n"
}